import { bostaHttp } from 'http.js';

export const getSubscriptionsList = () => {
  return bostaHttp.get('/subscriptions/offered');
};

export const getPurchasedSubscription = () => {
  return bostaHttp.get('/subscriptions/purchasedSubscriptions');
};

export const subscribeCheckout = (payload) => {
  return bostaHttp.post('/subscriptions/checkoutLink', payload);
};

export const subscribeWithWallet = (payload) => {
  return bostaHttp.post('/subscriptions/subscribe', payload);
};

export const cancelSubscription = ({ id, payload }) => {
  return bostaHttp.post(`/subscriptions/${id}/cancel`, payload);
};

export const renewSubscription = ({ id }) => {
  return bostaHttp.post(`/subscriptions/${id}/renew`);
};

export const fetchPaymentMethods = () => {
  return bostaHttp.get('/subscriptions/profile/paymentMethods');
};
